module.exports = __webpack_public_path__ + "img/zeigling11.61dce1a5.jpg";